import { Utils } from "./utils";
const root = document.documentElement;
const navigation = document.querySelector("nav");
let navbarCollapse = null;
let navShown = false;
// Add an "!" before a classname to remove the class on scroll rather than add it
const navAddClasslist = ["show-border", "!navbar-transparent"];
if (navigation != null) {
    const navigationContents = navigation.children[0].children;
    for (var i = 0; i < navigationContents.length; i++) {
        var child = navigationContents[i];
        if (child.classList.contains("navbar-collapse")) {
            navbarCollapse = child;
        }
    }
}
export class Navigation {
    /**
     * Navigation functionality to run on load.
     */
    NavigationOnLoad() {
        if (navigation != null) {
            if (root != null) {
                Utils.copyHeight(navigation, root, "--nav-height");
            }
            const scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
            navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, scrollTop);
        }
    }
    /**
     * Navigation functionality to run on page resize.
     */
    NavigationOnResize() {
        if (navigation != null) {
            if (root != null) {
                if (navbarCollapse != null) {
                    if (!navbarCollapse.classList.contains("show")) {
                        Utils.copyHeight(navigation, root, "--nav-height");
                    }
                }
                else {
                    Utils.copyHeight(navigation, root, "--nav-height");
                }
            }
            navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, (document.documentElement || document.body.parentNode || document.body).scrollTop);
        }
    }
    /**
     * Navigation functionality to run on page scroll.
     */
    NavigationOnScroll() {
        const scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if (scrollTop == 0) {
            navShown = false;
        }
        if (!navShown) {
            if (navigation != null) {
                navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, scrollTop);
            }
        }
    }
}
